import React from 'react';
import { useSearchParams } from 'react-router-dom';
import QuickAppointmentForm from './QuickAppointmentForm';

/**
 * Eigenständige Seite für die Schnellerfassung (/admin/quick-appointment).
 * Optionaler ?date=YYYY-MM-DD Query vorbelegt das Datum (z. B. aus Kalender).
 */
const QuickAppointmentPage: React.FC = () => {
  const [params] = useSearchParams();
  const initialDate = params.get('date') || undefined;

  return (
    <div className="py-2">
      <QuickAppointmentForm variant="page" initialDate={initialDate} />
    </div>
  );
};

export default QuickAppointmentPage;
